import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, AfterViewInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CustomDropdownBottomComponent } from './bottom/custom-dropdown-bottom.component';
import { MediasQueryService } from '../../services/medias-query.service';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { PartnersAccountModalComponent } from 'src/app/contexts/partners/pages/detail/modals/partners-account-modal.component';
import { KeycloakService } from 'keycloak-angular';
import { SettingsService } from '../../../contexts/settings/settings.service';
import { environment } from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html'
})
export class CustomDropdownComponent implements OnInit, OnDestroy {

  @Input() items: any[];
  @Input() display = 'name';
  @Input() selectedItem: any;
  @Input() partner: any;
  @Input() account: any;
  @Input() user;
  @Output() change = new EventEmitter<any>();
  @Output() settings = new EventEmitter<any>();
  can_add: boolean = false;
  model: any = {};
  mediasQuerySubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private bottomSheet: MatBottomSheet,
    private mediasQueryService: MediasQueryService,
    private userService: UserService,
    private dialog: MatDialog,
    private keycloak: KeycloakService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {

    if (this.user.portal == 'console')
      this.can_add = environment.features.console.find(p => p.key == 'create_account')?.enabled;

    this.items.forEach(element => {
      if (element.configurations) {
        let obj = JSON.parse(element.configurations);
        element.color = obj.Frontend ? obj.Frontend.Color : '#000';
      }
      else
        element.color = '#000';
    });

    this.changeItem(this.selectedItem ?? this.items[0]);
    this.mediasQuerySubscription = this.mediasQueryService.isMobile().subscribe(result => this.model.isMobile = result);
    this.route.paramMap.subscribe(params => {
      this.model.partner = params.get('partner');
      this.model.account = params.get('account');
    });
  }

  changeItem(item: any) {
    this.selectItem(item);
    this.change.emit(item);
  }

  settingsItem(item: any) {
    this.selectItem(item);
    this.settings.emit(item);
  }

  selectItem(item) {
    this.selectedItem = item;
    this.model.open = false;
    this.firstLetter();
  }

  openItems() {
    if (this.model.isMobile) {

      const bottomRef = this.bottomSheet.open(CustomDropdownBottomComponent, {
        data: {
          items: this.items,
          display: this.display,
          selectedItem: this.selectedItem,
          partner: this.model.partner,
          account: this.model.account
        }
      });

      bottomRef.afterDismissed().subscribe(result => {
        if (result) {
          if (result.redirectTo === 'transactions') {
            this.changeItem(result.item);
          } else {
            this.settingsItem(result.item);
          }
        }
      });
    }
    else {
      this.model.open = !this.model.open;
    }
  }

  firstLetter() {
    this.model.firstLetter = this.selectedItem[this.display]?.charAt(0);
  }

  ngOnDestroy() {
    this.mediasQuerySubscription.unsubscribe();
  }

  addAccount() {
    const dialog = this.dialog.open(PartnersAccountModalComponent, {
      width: '700px',
      data: {
        partner: this.model.partner,
        account: this.model.account,
        partner_obj: { key: this.model.partner, user: { username: this.userService.user.email } }
      },
      autoFocus: false
    });

    dialog.afterClosed().subscribe(async result => {
      if (result) {
        const newAccount = {
          key: result.accounts[0].account_key,
          name: result.accounts[0].account_name,
          status: "N",
          color: "#000000"
        };
        this.items.push(newAccount);

        var user = await this.keycloak.loadUserProfile(true);
        console.log(user);

        this.keycloak.updateToken(-1).then((refreshed) => {
          if (refreshed) {
            console.log('refreshed ' + new Date());
          } else {
            console.log('not refreshed ' + new Date());
          }

          this.changeItem(newAccount);
        });

        this.settingsService.changeUser(user);
      }
    });
  }
}
